import { render, staticRenderFns } from "./AddAgentBusinessView.vue?vue&type=template&id=16307468&scoped=true"
import script from "./AddAgentBusinessView.vue?vue&type=script&lang=js"
export * from "./AddAgentBusinessView.vue?vue&type=script&lang=js"
import style0 from "./AddAgentBusinessView.vue?vue&type=style&index=0&id=16307468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16307468",
  null
  
)

export default component.exports